module.exports = __webpack_public_path__ + "img/software-function.f99151e7.png";